import React from 'react';
import CountDetail from './CountDetail';

/** Legacy /countsApproval/:id: the count page, which shows approvers their actions. */
const CountApprovalDetail = () => <CountDetail />;

export default CountApprovalDetail;
